import React, { useContext, useEffect, useState } from 'react'
import { renderToString, renderToStaticMarkup } from 'react-dom/server';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import { observer } from 'mobx-react-lite'
import { Case, Switch } from 'react-if'
import RootStoreContext from '../../../storage/RootStore'
import { ABOUT_STAGES, ABOUT_DOCUMENTS, ABOUT_PROBLEMS, ABOUT_STRUCTURE } from '../../../dict/ABOUT'
import { HorizontalLine } from '.';

/// functions
/// types
/// components

interface TitlesProps { }

export const Titles: React.FC<TitlesProps> = observer(() => {


    const { selection } = useContext(RootStoreContext)

    return (<>
        <Switch>
            <Case condition={selection.view === 'stages'}>

                <TextHtml>
                    {ABOUT_STAGES}
                </TextHtml>

            </Case>
            <Case condition={selection.view === 'documents'}>


                <TextHtml>
                    {ABOUT_DOCUMENTS}
                </TextHtml>




            </Case>
            <Case condition={selection.view === 'problems'}>


                <TextHtml>
                    {ABOUT_PROBLEMS}
                </TextHtml>


            </Case>
            <Case condition={selection.view === 'structure'}>


                <TextHtml>
                    {ABOUT_STRUCTURE}
                </TextHtml>

            </Case>

        </Switch>


    </>
    )
})




export const TextHtml = (props: { children: string }) => {

    return (<>
        {props.children.split('@').map(str => {

            if (str.includes('*')) {
                return <ul>
                    {str.split('*')
                        .filter(item => item.length > 1)
                        .map(item => item.trim())
                        .map(item => {
                            return <li>{ReactHtmlParser(item)}</li>
                        })}
                </ul>
            }
            else return <p>{ReactHtmlParser(str)}</p>
        })}

    </>)

}